import React from "react";
import { CommonService } from "@services";

const Footer = ({ customFooter, className }) => {
  customFooter = CommonService.htmlDecode(customFooter ?? "");
  if (customFooter != null) {
    customFooter = CommonService.replaceDatePlaceholders(customFooter);
  }
  return (
    <div className="norstella-cf-footer" part="cfDivFooter">
      <div
        className={className}
        part="cfDivCustomFooterText"
        dangerouslySetInnerHTML={{ __html: CommonService.sanitizeHTML(customFooter) }}
      ></div>
    </div>
  );
};

export default Footer;
